module.exports = __webpack_public_path__ + "static/media/car1.b70c3d0a.png";